import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../constant/queryKey';
import { affiliateService } from 'shared/src/api/affiliateService';
import { useGoodsSno } from '../hooks/useGoodsSno';

export const useAffiliateGoods = () => {
  const goodsSno = useGoodsSno();

  return useQuery({
    queryKey: queryKey.affiliateGoods(goodsSno),
    queryFn: () => affiliateService.getAffiliateGoods(goodsSno),
  });
};
